<template>
    <div class="wrapper">
        <b-container>
            <mini-nav class="mt-4"></mini-nav>
            <six-angle :dataList="list"></six-angle>
        </b-container>
    </div>
</template>
<script>
import miniNav from '@/views/about/miniNav/miniNav.vue';
import sixAngle from '@/components/sixAngle.vue'
export default {
    components:{ miniNav, sixAngle },
    data(){
        return{
            list: []
        }
    },
    created(){
        this.getCharacterList()
    },
    methods:{
         getCharacterList(){
            this.$api.characterList({
                type: 6
            })
            .then(res=>{
                this.list = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>